<template>
  <div class="visaOrder full-height linear-main3">
    <ld-header
      @click-left="$router.push({ path: '/allOrder?findType=1' })"
      transparent
      white
    >
      <span class="font12">{{ $t('F001','订单号') }}：{{ detail.orderNo }}  &nbsp;{{ detail.tripTypeStr }}</span>
    </ld-header>

    <van-pull-refresh
      style="padding-bottom: 50px;"
      v-model="isLoading"
      @refresh="getDetail"
    >
      <div class="white pad8">
        <van-row class="font-lg font24 mt5">
          {{ detail.orderStatusRemark }}
        </van-row>
        <van-row class="font12 mt5">
          {{ $t('F002','预订时间') }}：{{ detail.bookDate }}
        </van-row>
        <van-row class="font12 mt5">
          {{ $t('F003','预订人') }}：{{ detail.bookerName }}
        </van-row>
      </div>

      <div
        class="pad8"
        v-if="detail.orderNo"
      >
        <div class="round-sm mt5">
          <DetailPanel
            class="bg-white van-hairline--bottom"
            :detail="detail"
          >
            <van-row class="mt5">
              <van-col span="12">
                <label>出行日期：</label>
                {{ detail.tripDate }}
              </van-col>
              <van-col
                v-if="detail.isShowFillSendInfo"
                span="12"
                class="text-right main-color"
                @click="showSendInfo = true"
              >
                {{ detail.expressCompany ? '修改寄送信息' : '补填寄送信息' }}
              </van-col>
            </van-row>
          </DetailPanel>
          <van-row
            v-if="detail.isShowProgress"
            class="font12 bg-white pad8 text-center main-color"
            @click="showProgress = true"
          >
            办理进度
          </van-row>
        </div>

        <div class="round-sm mt5">
          <traver
            :traveler-list="detail.personList"
            :disabled="true"
            :add-button="false"
            :title="$t('F006','出行人')"
          />
        </div>

        <!-- 寄出信息 -->
        <div
          v-if="detail.isShowFillSendInfo && detail.expressCompany"
          class="bg-white mt5 round-sm pad8"
        >
          <van-row>寄出信息</van-row>
          <van-row class="mt5">
            <van-col span="12">
              <label>快递公司：</label>
              {{ detail.expressCompanyName }}
            </van-col>
            <van-col span="12">
              <label>快递单号：</label>
              {{ detail.expressNumber }}
            </van-col>
          </van-row>
          <van-row class="mt5">
            <label>备注信息：</label>
            {{ detail.expressRemark }}
          </van-row>
        </div>

        <div
          v-if="detail.isShowFillSendInfo && detail.addressee"
          class="bg-white mt5 round-sm pad8"
        >
          <van-row>寄回信息</van-row>
          <van-row class="mt5">
            <van-col span="12">
              <label>收件姓名：</label>
              {{ detail.addressee }}
            </van-col>
            <van-col span="12">
              <label>收件电话：</label>
              {{ detail.addresseePhone }}
            </van-col>
          </van-row>
          <van-row class="mt5">
            <label>支付方式：</label>
            {{ detail.kdPayMethodName }}
          </van-row>
          <van-row class="mt5">
            <label>收签地址：</label>
            {{ detail.addresseeSite }}
          </van-row>
          <van-row class="mt5">
            <van-col
              v-if="detail.sendBackExpressCompanyName"
              span="12"
            >
              <label>快递公司：</label>
              {{ detail.sendBackExpressCompanyName }}
            </van-col>
            <van-col
              v-if="detail.sendBackNumber"
              span="12"
            >
              <label>快递单号：</label>
              {{ detail.sendBackNumber }}
            </van-col>
          </van-row>
        </div>

        <!-- 差旅信息 -->
        <travel-info
          class="mt5 round-sm"
          ref="travelinfo"
          :travel-data="detail"
          :details="true"
        />

        <!-- 审批规则 -->
        <approval
          class="mt5 round-sm"
          v-if="detail.appId"
          :vip-status="detail.vipStatus"
          :order-id="id"
          :spgz-id="detail.appId"
        />
      </div>
    </van-pull-refresh>


    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        class="full-width bg-white shadow"
        type="flex"
        align="center"
        justify="space-between"
        @click="$refs['tabbar'].toggle()"
      >
        <van-col
          span="11"
          :offset="1"
        >
          <span class="font10 red">&yen;</span>
          <span class="font24 red">{{ detail.totalPrice }}</span>
          <span class="font10 gray">{{ $t('E017','共') }}{{ detail.personList && detail.personList.length }}人</span>

          {{ $t('E006','明细') }}
          <van-icon
            name="arrow-up"
            class="vertical-middle"
            size="14"
          />
        </van-col>
        <van-col
          span="6"
          class="pad5"
        >
          <ld-button
            defaults
            size="md"
            v-if="detail.isShowCancel==1"
            @click.stop="btnClick('cancel')"
          >
            {{ $t('B008','取消') }}
          </ld-button>
        </van-col>
        <van-col
          span="6"
          class="pad5"
        >
          <ld-button
            main
            size="md"
            v-if="detail.isShowCancelApproval == 1"
            @click.stop="btnClick('revertApproval')"
          >
            {{ $t('B065','撤回') }}
          </ld-button>

          <ld-button
            main
            size="md"
            v-if="detail.isShowApproval == 1"
            @click.stop="btnClick('approval')"
          >
            {{ $t('B028','送审') }}
          </ld-button>

          <ld-button
            main
            size="md"
            v-else-if="detail.isShowApproval == '2'"
            @click.stop="approval()"
            class="font10"
          >
            {{ $t('Submit','再送审') }}
          </ld-button>

          <ld-button
            main
            size="md"
            v-else-if="detail.isShowPay==1"
            @click.stop="pay"
          >
            {{ $t('B014','支付') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 支付 -->
    <!-- <ld-pay
      ref="pay"
      :order-type="detail.orderType"
      :order-id="id"
    /> -->

    <SendInfo
      :detail="detail"
      :visibility.sync="showSendInfo"
      @submit="fillSendInfo"
    />

    <!-- 办理进度 -->
    <van-popup
      v-model="showProgress"
      :close-on-popstate="true"
      :style="{ width: '80%' }"
    >
      <div style="padding: 16px;">
        <h3 class="text-center">
          办理进度
        </h3>
        <van-steps
          class="ld-step m-b-5 font14"
          direction="vertical"
        >
          <van-step
            v-for="progress in progressList"
            :key="progress.blzt"
          >
            <van-row>
              <van-col span="12">
                {{ progress.blztName }}
              </van-col>
              <van-col
                span="12"
                class="text-right"
              >
                {{ progress.remark }}
              </van-col>
            </van-row>
            <p class="gray font12">
              {{ progress.createdate }}
            </p>
          </van-step>
        </van-steps>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Step, Steps, Popup } from 'vant'
import mixin from './detailMixin'
import SendInfo from './SendInfo'
import traver from '../visaQuery/visaEdit/traver'
import travelInfo from 'Components/travelInfo'
import approval from 'Components/approval/approval'

import VisaOrderInteractor from 'Domain/use-cases/visa-order-interactor'

export default {
  provide: {
    orderType: $dict.ORDER_TYPE.visa
  },
  name: 'VisaOrder',
  mixins: [mixin],
  components: {
    travelInfo,
    traver,
    SendInfo,
    approval,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Popup.name]: Popup
  },
  data () {
    return {
      showSendInfo: false,
    }
  },
  methods: {
    async fillSendInfo (info) {
      try {
        await VisaOrderInteractor.fillSendInfo({
          orderId: this.id,
          ...info
        })
        this.showSendInfo = false
        this.getDetail()
        this.$dialog({ message: '保存成功' })
      } catch (error) {
        if (typeof error === 'string') this.$toast(error)
      }
    }
  },
  computed: {
  }
}
</script>

<style lang="less">
.visaOrder {

  p {
    margin: 0;
  }

  label {
    color: @color-text-gray;
  }

  .pad5 {
    padding: 5px;
  }

  h3 {
    margin: 0;
    margin-bottom: 8px;
  }

  .pad8 {
    padding: 8px;
  }

  .mt5 {
    margin-top: 5px;
  }

  .round-sm {
    overflow: hidden;
  }

  .order-status__icon {
    vertical-align: middle;
  }
}
</style>

